'use strict';

import {addCustomExportBtns} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";

export var fnRolesTable = function () {

    var tableName = '#datatable-roles';

    if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName)) return false;

    var columns = [
        {data: 'id'},
        {data: 'companies_string'},
        {data: 'permissions_string'},
        {data: 'name'},
        {data: 'display_name'},
        {data: 'description'},
        {data: 'is_client_text'},
        {data: 'permissions_text'},
        {data: 'companies_text'},
        {data: 'action'},
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {visible: false, targets: 0},
        {visible: false, targets: 1},
        {visible: false, targets: 2},
        {visible: true, targets: 3},
        {visible: true, targets: 4},
        {visible: true, targets: 5},
        {visible: true, targets: 6},
        {visible: true, targets: 7},
        {visible: true, targets: 8},
        {visible: true, targets: 9},
    ];


    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');
    $.fn.dataTable.moment('DD/MM/YYYY');

    var table = $(tableName).DataTable({

        language: allLangFiles.datatables,
        rowId: 'id',
        ajax: {
            url: '/roles/load-table',
            dataSrc: function (json) {

                return json.data;
            },
        },
        scrollX: true,
        columns: columns,
        columnDefs: columnDefs,
        /*scrollX: true,*/
        lengthMenu: [[-1, 10, 25, 50, 75, 100], [allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
    });
    //addSearchColumn(tableName, table);
    addCustomExportBtns($(tableName), [0, 3, 4, 5, 6, 1, 2],
        'roles'
    );

    const { $filterButtons } = redesignDataTablesHeader(tableName, true, null, false);
    $filterButtons.prepend($('#btn-create-role'));
};